import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';
import { companiesQueryKeys } from '@/modules/companies/queries/queryKeys';
import type { ApiRequestBody } from '@/types/utils/request';
import { invalidateQuery } from '@/utils/queries';

type CreateCompanyNoteRequestBody = ApiRequestBody<
  typeof endpoints.companyNotes,
  'post'
>;
type CreateCompanyNoteParams = {
  companyId: string;
  body: CreateCompanyNoteRequestBody;
};

export const useCreateCompanyNoteMutation = () => {
  return useMutation({
    mutationFn: async ({ companyId, body }: CreateCompanyNoteParams) => {
      const { data } = await fetchClient.POST(endpoints.companyNotes, {
        params: { path: { id: companyId } },
        body,
      });

      return data;
    },
    onSettled: (_data, _error, { companyId }) => {
      invalidateQuery(companiesQueryKeys.notes(companyId))();
    },
  });
};
